import { UserPayload } from "../models/SiteModel";

const getResponseMessage = async (response: Response) => {
  const contentType = response.headers.get("content-type") ?? "";

  if (contentType.includes("application/json")) {
    const data = await response.json();
    return data?.message ?? data?.Message ?? data?.title ?? response.statusText;
  }

  const text = await response.text();
  return text || response.statusText;
};

export async function fetchValidarUsuario(userName: string, password: string, conexion: string) {
  const URLAPI = process.env.REACT_APP_BASE_URL;
  const postData = JSON.stringify({
    Conexion: conexion,
    Username: userName,
    Password: password
  });
  const response = await fetch(
    `${URLAPI}/Auth/LoginValidation`,
     {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: "include",
      body: postData
    }
  );

  if (response.status === 401) {
    throw new Error("Usuario o contrasena incorrectos.");
  }

  if (!response.ok) {
    const message = await getResponseMessage(response);
    throw new Error(message || "No se pudo iniciar sesion.");
  }

  const data = await response.json();
  return data;
}

export async function fetchCerrarSesionOAuth(token?: string) {
  const URLAPI = process.env.REACT_APP_BASE_URL;
  await fetch(`${URLAPI}/Auth/CerrarSesionOAuth`, {
    method: "POST",
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
}

export async function fetchGetAutorizacionesPendientes(user: UserPayload) {
  const URLAPI = process.env.REACT_APP_BASE_URL;
  const token = user.token;
  const response = await fetch(
    `${URLAPI}/Auth/GetAutorizacionesPendientes`,
     {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
    }
  );

  const data = await response.json();
  return data;
}

export async function fetchAutorizarUsuario(user: UserPayload, idAutorizacion: number, idUsuario: number, ejecucionesPermitidas:number | undefined) {
  const URLAPI = process.env.REACT_APP_BASE_URL;
  const token = user.token;

  const postData = JSON.stringify({
    ID_AUTORIZACION: idAutorizacion,
    ID_USUARIO: idUsuario,
    Ejecuciones_Permitidas: ejecucionesPermitidas??null
  });

  const response = await fetch(
    `${URLAPI}/Auth/Autorizar`,
     {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: postData
    }
  );

  const data = await response.json();
  return data;
}
